import React, { FC, useState } from 'react';
import { Box, TextField, } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
    handleSubscriptionCatalogSync
} from '../../../store/software-library-management/actions';
import ResponsiveContainer from './responsive-command-container';
import useStyles from './styles';

const SubscriptionCatalog: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [userId, setUserId] = useState<string>('');
    const [applicationId, setApplicationId] = useState<string>('');

    const handleSync = async () => {
        const isSync = await dispatch(handleSubscriptionCatalogSync(userId, applicationId));
        if (isSync) {
            setUserId("");
            setApplicationId("");
        }
    };

    return (
        <ResponsiveContainer
            dropdowns={
                <>
                    <Box px={1}>
                        <TextField
                            variant="standard"
                            id="userId"
                            label="User Id"
                            className={classes.textBox}
                            value={userId}
                            type="text"
                            onChange={(event) => {
                                setUserId(event.target.value);
                            }}
                        />
                    </Box>
                    <Box px={3}>
                        <TextField
                            variant="standard"
                            id="applicationId"
                            label="Application Id"
                            className={classes.textBox}
                            value={applicationId}
                            onChange={(event) => {
                                setApplicationId(event.target.value);
                            }}
                        />
                    </Box>
                </>
            }
            button={{
                id: 'sync-button',
                clickCallBack: handleSync,
                doubleCheck: true,
            }}
        />
    );
};

export default SubscriptionCatalog;
